var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"cart-title mb-4"},[_vm._v("Haftalık Rezervasyon Girişleri")]),_c('div',{staticClass:"apex-charts",attrs:{"id":"donut-chart"}},[_c('apexchart',{staticClass:"apex-charts",attrs:{"options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }